export enum TicketTypeEnum {
    Serve = 1,
    FullTraceEnquiries = 2,
    DesktopTrace = 3,
    FieldAgentEnquiries = 4,
    StatusReport = 5,
    OccupancyCheck = 6,
    Surveillance = 7,
    Affidavit = 8,
    GeneralEnquiries = 9
}
